import {addAndRunAnalysisSteps} from 'analysis-tool/AnalysisActions';
import {
  SINGLE_DATASET_INPUT_STEP_DATA_NAME,
  SINGLE_DATASET_OUTPUT_STEP_DATA_NAME,
} from 'analysis-tool/AnalysisStepDataNames';
import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {
  AnalysisMainViewItem,
  AnalysisMainViewItemType,
  DataReference,
} from 'analysis-tool/ui/main-view/MainViewTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {withLoadingScreen} from 'util/Promises';

async function createViewAndRegressionStep(
  analysis: AnalysisGraphQL,
  inputDataFrameId: string,
  inputDataReference: DataReference
): Promise<Array<GetAnalysisPipelineStep>> {
  return await addAndRunAnalysisSteps(analysis.id, [
    {
      stepType: PipelineStepType.DATASET_VIEW,
      stepVersion: 0,
      stepConfig: {},
      stepInputParents: {
        [SINGLE_DATASET_INPUT_STEP_DATA_NAME]: [inputDataReference],
      },
      stepInput: {inputDataFrameId},
      runStep: true,
    },
    {
      stepType: PipelineStepType.REGRESSION,
      stepVersion: 0,
      stepConfig: {
        name: 'Regression',
      },
      stepInputParents: {
        [SINGLE_DATASET_INPUT_STEP_DATA_NAME]: [{stepDataName: SINGLE_DATASET_OUTPUT_STEP_DATA_NAME}],
      },
      runStep: false,
    },
  ]);
}

export interface CreateViewAndOpenRegressionViewParams {
  analysis: AnalysisGraphQL;
  inputDataFrameId: string;
  inputDataReference: DataReference;
  onOpenStepInitializationView: (newSelectedItem: AnalysisMainViewItem) => void;
}

export default async function createViewAndOpenRegressionView({
  analysis,
  inputDataFrameId,
  inputDataReference,
  onOpenStepInitializationView,
}: CreateViewAndOpenRegressionViewParams): Promise<void> {
  const newSteps = await withLoadingScreen<Array<GetAnalysisPipelineStep>>(
    createViewAndRegressionStep(analysis, inputDataFrameId, inputDataReference),
    'Creating regression...'
  );

  onOpenStepInitializationView({
    type: AnalysisMainViewItemType.EDIT_REGRESSION,
    stepId: newSteps[newSteps.length - 1].id,
  });
}
